import { orderConfirmationTotalStyles } from "@guestsupply/Overrides/Widgets/OrderConfirmation/OrderConfirmationTotal";
import { css } from "styled-components";

orderConfirmationTotalStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};
